/* All site copy and links live here so content stays separate from layout. */

import tourify from "../Assets/Projects/Tourify.png";
import chatify from "../Assets/Projects/chatapp.png";
import preserve from "../Assets/Projects/preserve.png";
import simon from "../Assets/Projects/simon.png";
import lcsl from "../Assets/Projects/lcsl.png";
import nostag from "../Assets/Projects/nostag.png";
import mkc from "../Assets/Projects/mkc.png";
import jokeblog from "../Assets/jokeblog.png";
import ccblog from "../Assets/ccblog.png";

export const profile = {
  name: "Dharmik Batra",
  greeting: "Hi There!",
  roles: ["Technology Enthusiast", "Entrepreneur", "Software Developer"],
  facts: [
    { label: "Currently", value: "Software Engineer, Toast Inc." },
    { label: "Education", value: "Computer Science, BITS Pilani" },
    { label: "Based in", value: "Haryana, India" },
  ],
  quote: "Strive to build things that make a difference!",
  quoteAuthor: "Dharmik",
};

export const socials = {
  github: {
    name: "GitHub",
    handle: "@dharmikbatra",
    url: "https://github.com/dharmikbatra",
  },
  twitter: {
    name: "X / Twitter",
    handle: "@im_db___",
    url: "https://x.com/im_db___",
  },
  linkedin: {
    name: "LinkedIn",
    handle: "in/dharmikbatra",
    url: "https://www.linkedin.com/in/dharmikbatra/",
  },
  medium: {
    name: "Medium",
    handle: "@batradharmik",
    url: "https://medium.com/@batradharmik",
  },
};

/* The footer historically linked a different set of handles — kept as-is. */
export const footerSocials = {
  github: "https://github.com/dharmikbatra",
  twitter: "https://twitter.com/DharmikBatra",
  linkedin: "https://www.linkedin.com/in/dharmikbatra/",
  instagram: "https://www.instagram.com/dharmikbatra/",
};

export const repoUrl = "https://github.com/dharmikbatra/portfolio";
export const nostagUrl = "https://www.nostag.in";

/* "Beyond Work & Code" */
export const interests = [
  { label: "Travelling" },
  { label: "Content Writing" },
  { label: "Playing Badminton" },
  { label: "Watching Bollywood Movies" },
  { label: "Stand Up Comedy" },
];

export const intro = {
  heading: "Let me introduce myself",
  lead:
    "I am a second-time founder and Software Development Engineer on the Payments team at Toast Inc., with experience across fintech infrastructure, networking systems, and startup execution.",
  timelineHeading: "Here's my journey so far (latest first):",
};

/* Longer-form bio shown alongside the timeline. */
export const bio = [
  "I am a second-time founder and a Computer Science graduate from BITS Pilani, currently working as a Software Development Engineer on the Payments team at Toast Inc.",
  "I previously worked at Cisco Systems as both a Software Engineering Intern and a full-time Software Engineer.",
  "My entrepreneurial journey began with a cloud kitchen startup, where I gained hands-on experience managing high-burn operations, hyper-local liquidity, and strict unit economics.",
  "At Toast, I build and scale complex financial infrastructure and high-volume payment flows.",
];

/* Rendered with an inline link on "NoStag". */
export const bioClosing = {
  before: "Now, I am combining my operational grit with deep fintech expertise to launch ",
  linkLabel: "NoStag",
  linkUrl: nostagUrl,
  after:
    " - a trust-based, on-demand marketplace engineered to solve the massive stag-entry friction in India's nightlife economy through secure escrow and instant payout architecture.",
};

export const timeline = [
  {
    period: "Jul 2025 - Present",
    title: "Software Engineer, Toast Inc.",
    details:
      "Building and scaling high-volume payment and payout systems on the Payments team.",
  },
  {
    period: "Founder Journey",
    title: "Cloud Kitchen -> NoStag",
    details:
      "Started with a cloud kitchen venture and now building NoStag, a trust-based nightlife marketplace powered by secure escrow and instant payout architecture.",
  },
  {
    period: "Aug 2023 - Jul 2025",
    title: "Software Engineer, Cisco Systems",
    details:
      "Built backend services and IOS-XR features focused on networking reliability.",
  },
  {
    period: "Jan 2023 - Jun 2023",
    title: "Software Engineering Intern, Cisco Systems",
    details: "Worked on automation and large-scale sanity check workflows.",
  },
  {
    period: "2019 - 2023",
    title: "B.E. (Hons), Computer Science, BITS Pilani",
    details: "Completed a 4-year engineering degree in Computer Science.",
  },
];

export const skillGroups = [
  {
    title: "Languages",
    items: ["Java", "Kotlin", "C++", "JavaScript", "Python"],
  },
  {
    title: "Frameworks",
    items: [
      "React",
      "React Native",
      "NodeJS",
      "Spring Boot",
      "Express",
      "NestJS",
      "Dropwizard",
    ],
  },
  {
    title: "Backend",
    items: [
      "Socket Programming",
      "Databases",
      "REST API",
      "GraphQL",
      "Microservices",
      "API Gateway",
      "JWT",
      "Docker",
      "Kubernetes",
      "Git",
    ],
  },
];

export const tools = [
  "IntelliJ IDEA",
  "Visual Studio Code",
  "XCode",
  "Postman",
  "GitHub",
  "Docker",
  "CursorAI",
  "DevinAI",
  "Claude Code",
  "ChatGPT",
  "PgAdmin4",
  "DBeaver",
];

/* Products and businesses I'm building. */
export const ventures = [
  {
    title: "No Stag",
    image: nostag,
    description:
      "Two-way marketplace for couple matchup near clubs and bars (In Progress)",
    /* origin/master has pageLink "#", i.e. no live page yet. */
    url: null,
  },
  {
    title: "MKC (Marvelous Kitchen Creations)",
    image: mkc,
    description:
      "Cloud kitchen startup for delivering last minute, quick, and healthy meals to customers",
    url: "https://www.linkedin.com/company/mkc-marvelous-kitchen-creations/about/",
  },
];

export const projects = [
  {
    title: "Tourify",
    image: tourify,
    description:
      "Web application similar to Make My Trip where one can book the tours, review the tours. Admin can manage the bookings and add new tours very easily. It also has a integrated payment gateway",
    repo: "https://github.com/dharmikbatra/MMT-clone",
    demo: "https://mmt-clone.onrender.com/",
    featured: true,
  },
  {
    title: "Chatify",
    image: chatify,
    description:
      "Personal Chat Room or Workspace to share resources and hangout with friends build with node.js, Sockets and Material-UI. Have features which allows user for realtime messaging, location sharing.",
    repo: "https://github.com/dharmikbatra/node-chat-app",
    demo: "https://dharmikbatra-chat-app.herokuapp.com/",
    featured: true,
  },
  {
    title: "Preserve-Memories",
    image: preserve,
    description:
      "A online album like drive where user can save his memories with descrpition and tags along with the images. Build with React.js and Node.js which takes the content from user and stores it in MongoDB.",
    repo: "https://github.com/dharmikbatra/Preserve",
    demo: "https://elastic-leakey-dcd4c7.netlify.app/",
    featured: true,
  },
  {
    title: "Simon Game",
    image: simon,
    description:
      "Online game where users needs to remember a random color pattern whose length increases with every level Build with HTML, CSS, Javascript and JQuery",
    repo: "https://github.com/dharmikbatra/patgame/",
    demo: "https://dharmikbatra.github.io/patgame",
  },
  {
    title: "Leetcode Solutionare",
    image: lcsl,
    description:
      "I have put all my coding solutions at one place for anyone who wants some help in coding",
    repo: "https://github.com/dharmikbatra/DSA/",
  },
];

export const articles = [
  {
    title:
      "How to Start a Cloud Kitchen in an Aggregator-Dominant Food Industry",
    image: ccblog,
    description:
      "This article offers a practical guide to succeeding with a cloud kitchen in India's aggregator-dominated food industry. It emphasizes balancing reliance on delivery apps with building direct customer channels, strong branding, great food photos, and strategic marketing to ensure profitability.",
    url: "https://medium.com/@batradharmik/how-to-start-a-cloud-kitchen-in-an-aggregator-dominant-food-industry-0faf54e29164",
  },
  {
    title: "How to Write a Joke: The Art of Premise, Setup, and Punchline",
    image: jokeblog,
    description:
      "This article explains the essential structure of a joke—premise, setup, and punchline—and offers practical tips on timing, audience awareness, and engagement. It guides readers on crafting effective, surprising jokes that connect well with different audiences.",
    url: "https://medium.com/@batradharmik/how-to-write-a-joke-the-art-of-premise-setup-and-punchline-60dbcdf4b567",
  },
];

export const tweetIds = [
  "1959142647161102414",
  "1884305029714305350",
  "1955862741798801707",
  "1952622776172544488",
  "1904245401387208978",
  "1909160215619993818",
  "1917239185351860498",
  "1919783990401335705",
  "1933460836422726095",
  "1945443179781636499",
  "1886161044436918786",
  "1885398845703807326",
  "1956268906844447101",
];
